<!--
 * @Description: 申请提现弹窗
 * @Author: gaohc
 * @Date: 2022-10-19 16:43:52
-->
<template>
  <div class="apply-withdraw-body">
    <el-dialog width="556px" title="提 现" :visible.sync="visible" :close-on-click-modal="false"
      @open="initData" :before-close="handleCancel" center>
      <div class="item-wrap">
        <div class="cell-item">
          <div class="cell-title">总金额：</div>
          <div>
            <span class="withdraw-amount">
              {{ withdrawData.canWithdrawAmount }}
            </span>
            <span>元</span>
          </div>
        </div>
        <div class="cell-item">
          <div class="cell-title">收款账户：</div>
          <el-select v-model="bankCardId" placeholder="请选择"
            size="small" style="width: 300px;">
            <el-option
              v-for="item in withdrawData.bankDoList"
              :key="item.cardId"
              :label="item.bankLabelText"
              :value="item.cardId">
              <span style="float: left;color: #333;">{{ item.bankName }}</span>
              <span style="float: right; color: #333;">
                {{ item.bankCardNo }}
              </span>
            </el-option>
          </el-select>
        </div>
        <div class="cell-item" style="align-items: baseline;">
          <div class="cell-title">备注：</div>
          <el-input style="width: 300px;"
            type="textarea"  maxlength="30" show-word-limit
            resize="none" placeholder="请输入备注信息"
            v-model="remark" :rows="4">
          </el-input>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 认</el-button>
        <span class="tag-text">预计下个工作日到账</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
export default {
  name: 'ApplyWithdraw',

  props: ['visible', "institutionId"],

  data() {
    return {
      withdrawData: {},
      bankCardId: '',
      remark: ''
    }
  },
  
  methods:{
    handleConfirm() {
      if (!this.bankCardId) {
        this.$message({
          message: '请选择收款账户',
          type: 'warning'
        });
        return
      }
      this.handleWithdraw();
    },

    handleWithdraw() {
      let selectBankItem = this.withdrawData.bankDoList.find(u =>u.cardId == this.bankCardId);
      let params = {
        bankCardId: this.bankCardId,
        institutionId: this.institutionId,
        bankCardNo: selectBankItem.bankCardNo,
        remark: this.remark
      }
			let [header, esParam] = this.encryptionUtil.encryptAndSignBody(params,
				Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_WITH_DRAW,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.clearData();
        this.$emit("handle-withdraw", result.data);
      })
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog");
    },

    clearData() {
      this.withdrawData = {};
      this.remark = '';
      this.bankCardId = '';
    },

    initData() {
      let params = {institutionId :this.institutionId};
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_SHARING_INCOME_DO,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.withdrawData = result.data;

        if (this.withdrawData.bankDoList && this.withdrawData.bankDoList.length) {
          this.withdrawData.bankDoList.map(item=> {
            item.bankLabelText = item.bankName + `  (${item.bankCardNo})`;
          })
          this.bankCardId = this.withdrawData.bankDoList[0].cardId;
        }
      })
    }    
  },  
}
</script>

<style scoped>
.apply-withdraw-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.item-wrap {
  color: #333333;
  font-size: 14px;
}
.cell-item {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.cell-title {
  min-width: 100px;
  text-align: right;
  color: #657180;
  margin-right: 20px;
}
.withdraw-amount {
  font-size: 18px;
  color: #000;
  margin-right: 30px;
}
.dialog-footer {
  margin-top: 40px;
  text-align: center;
  position: relative;
}
.tag-text {
  color: #606266;
  font-size: 12px;
  position: absolute;
  left: 70%;
  top: 50%;
  margin-top: -8px;
}
</style>

<style>
.apply-withdraw-body .el-select .el-input__inner, .apply-withdraw-body .el-textarea__inner {
  color: #000;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/settlementacctlist/ApplyWithdraw.vue